import React from "react";

import { Grid } from "@mui/material";
import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import useStyles, { Logo, GridItemInfo, GridItemForm } from "./styles";

interface ApprovedScreenProps {
  logoSrc?: string;
  companyName?: string;
}

const APPROVE_IMAGE = require("../../../../../assets/img/company-approved.svg");

export const ApprovedScreen = (props: ApprovedScreenProps) => {
  const { logoSrc, companyName } = props;
  const { t: translate } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <GridItemInfo
        height="inherit"
        item
        padding="41px 52px 41px 52px"
        borderRadius="12px 0px 0px 12px"
        lg={6}
      >
        <Stack direction="column" height="100%">
          <Logo src={logoSrc} />
          <div className={classes.approveImageContainer}>
            <img className={classes.approveImage} src={APPROVE_IMAGE} />
          </div>
        </Stack>
      </GridItemInfo>
      <GridItemForm
        height="inherit"
        item
        md={12}
        lg={6}
        borderRadius="0px 12px 12px 0px"
        container
        justifyContent="center"
        alignItems="center"
      >
        <Grid item>
          <Stack alignItems="flex-start" justifyContent="center" height="100%" spacing={1}>
            <span aria-label="approvedTitle" className={classes.title}>{translate("theCompanyHasBeenApproved")}</span>
            <span aria-label="companyName" className={classes.subtitle}>{`${companyName ?? ""} ${translate(
              "nowIsReadyToRockAndRoll"
            )}`}</span>
          </Stack>
        </Grid>
      </GridItemForm>
    </>
  );
};
